export default {
    parseQueryString: function(hrefStr) {
        const splitStr = hrefStr.split("&")
        const urlObj = {}
        for(let i = 0; i < splitStr.length; i++){
            urlObj[splitStr[i].split("=")[0]] = splitStr[i].split("=")[1]
        }
        return urlObj
    },
    randomNum: function (minNum, maxNum) { // 生成 [minNum, maxNum]的数，包含minNum、maxNum
        return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10);
    }
}
